/**
 * Cart AJAX Functions v3.0
 * Compatible with cart-drawer.liquid
 */

// Utility function for fetch
async function fetchJSON(url, options) {
  const response = await fetch(url, options);
  if (!response.ok) throw new Error(`Error en ${url}: ${response.statusText}`);
  return response.json();
}

// Add to cart function - uses the cart drawer's refresh
async function addToCart(form) {
  if (window.showSpinner) window.showSpinner();
  try {
    const formData = new FormData(form);
    const variantId = formData.get('id');
    if (!variantId || variantId === 'undefined') {
      throw new Error('No se selecciono ninguna variante del producto.');
    }

    await fetchJSON('/cart/add.js', { method: 'POST', body: formData });

    // Update cart count
    const cartData = await fetchJSON('/cart.js');
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cartData.item_count;
      el.classList.remove('hidden');
      el.classList.add('animate-bounce');
      setTimeout(() => el.classList.remove('animate-bounce'), 1000);
    });

    // Open cart drawer using the function from cart-drawer.liquid
    if (typeof window.openCartAfterAdd === 'function') {
      window.openCartAfterAdd();
    } else if (typeof toggleCartDrawer === 'function') {
      toggleCartDrawer();
    }

  } catch (error) {
    console.error('Error en addToCart:', error);
    if (window.showNotification) {
      window.showNotification(error.message || 'Error al anadir al carrito', 'error');
    } else {
      alert(`Error: ${error.message}`);
    }
  } finally {
    if (window.hideSpinner) window.hideSpinner();
  }
}

// Listen to add to cart forms
document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('form[action="/cart/add"]');
  forms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      await addToCart(form);
    });
  });
});
